var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTechnology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "technology",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.61,1.31h-28A3.24,3.24,0,0,0,7.38,4.56V45.62a3.25,3.25,0,0,0,3.24,3.25h28a3.26,3.26,0,0,0,3.25-3.25V4.56A3.25,3.25,0,0,0,38.61,1.31Zm-14,45.18a2.08,2.08,0,1,1,2.08-2.08A2.08,2.08,0,0,1,24.62,46.49ZM39.7,39A1.72,1.72,0,0,1,38,40.7H11.25A1.72,1.72,0,0,1,9.53,39V8.56a1.72,1.72,0,0,1,1.72-1.72H38A1.72,1.72,0,0,1,39.7,8.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTechnology);
export default __webpack_public_path__ + "static/media/icon_technology.db63ce48a2339c5f6e3f90025be4fd36.svg";
export { ForwardRef as ReactComponent };